import styled, { keyframes } from "../../__compat__/styled-components/main.entry.mjs.mjs";
const fadeIn = keyframes `
  0% {
    opacity: 0;
    transform: translateY(-20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;
const fadeOut = keyframes `
  0% {
    transform: translateY(0%);
  }
  100% {
    transform: translateY(-500%);
  }
`;
export const StyledNotification = styled.div.withConfig({ displayName: "auir-611444a-StyledNotification", componentId: "auir-611444a-1mvnwn9" }) `
  position: relative;
  padding: var(${(props) => props.theme.responsive.spacing.m});
  background-color: var(${(props) => props.theme.colors.background.level[3]});
  filter: var(${(props) => props.theme.shadow.background.level[3]});
  align-items: flex-start;
  display: flex;
  justify-content: space-between;
  gap: var(${(props) => props.theme.responsive.spacing.m});
  z-index: 100002;
  width: calc(
    100vw - (3 * var(${(props) => props.theme.responsive.spacing.pageMargin}))
  );

  animation: ${(props) => (props.isOpen ? fadeIn : fadeOut)};
  animation-duration: 420ms;
  animation-timing-function: var(${(props) => props.theme.easing});

  @media (min-width: ${({ theme }) => theme.breakpoints.m}px) {
    width: 300px;
  }

  svg {
    flex-shrink: 0;
  }
`;
export const StyledButton = styled.button.withConfig({ displayName: "auir-611444a-StyledButton", componentId: "auir-611444a-1yy0ul2" }) `
  background: transparent;
  display: flex;
  align-items: baseline;
  justify-content: right;
  width: 48px;
  height: 48px;
  padding: 0;
  border: 0;
  cursor: pointer;

  &:hover {
    color: var(${(props) => props.theme.colors.interaction.primary.hover});
  }
`;
export const StyledTextWrapper = styled.div.withConfig({ displayName: "auir-611444a-StyledTextWrapper", componentId: "auir-611444a-dxiv8o" }) `
  display: flex;
  flex-direction: column;
  gap: var(${(props) => props.theme.responsive.spacing.xs});
`;
export const StyledContentWrapper = styled.div.withConfig({ displayName: "auir-611444a-StyledContentWrapper", componentId: "auir-611444a-1t91ky8" }) `
  display: flex;
  flex-direction: column;
`;
//# sourceMappingURL=Notification.styles.mjs.mjs.map